enum TxStatus {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  CONFIRM = 'CONFIRM',
  FAIL = 'FAIL',
}

export default TxStatus
